import React from 'react';
import PropTypes from 'prop-types';
import { canUseDOM } from 'exenv';

class ClientSideWrapper extends React.Component {
  render() {
    if (!canUseDOM || !this.props.children) {
      return null;
    }

    const desktopQuery = `(max-width: 767px)`;
    const shouldHideDesktop = window.matchMedia(desktopQuery).matches;

    const mobileQuery = `(min-width: 768px)`;
    const shouldHideMobile = window.matchMedia(mobileQuery).matches;

    if (this.props.showOnlyDesktop && !shouldHideDesktop) {
      return this.props.children;
    }

    if (this.props.showOnlyMobile && !shouldHideMobile) {
      return this.props.children;
    }

    return null;
  }
}

ClientSideWrapper.defaultProps = {
  showOnlyDesktop: false,
  showOnlyMobile: false,
  children: null
};

ClientSideWrapper.propTypes = {
  children: PropTypes.node,
  showOnlyDesktop: PropTypes.bool,
  showOnlyMobile: PropTypes.bool
};

export default ClientSideWrapper;
